<template>
  <b-container>
    <b-row>
      <b-col>
        <iq-card class="mx-3">
          <template v-slot:headerTitle>
            <h4 class="card-title">Kế toán tự động</h4>
          </template>
          <template v-slot:body>
            <b-row class="justify-content-center">
              <b-button-group class="mt-3">
                <b-button variant="primary" :class="{ active: filter.date === 1 }" @click="filter_date(1)">Hôm nay</b-button>
                <b-button variant="primary" :class="{ active: filter.date === 2 }" @click="filter_date(2)">Hôm qua</b-button>
                <b-button variant="primary" :class="{ active: filter.date === 3 }" @click="filter_date(3)">Tuần này</b-button>
                <b-button variant="primary" :class="{ active: filter.date === 4 }" @click="filter_date(4)">Tuần trước
                </b-button>
              </b-button-group>
            </b-row>
            <b-row class="mt-3">
              <b-col class="d-flex align-items-center justify-content-center flex-column flex-md-row">
                <b-form-group label="Từ ngày" label-for="from_date" class="mr-2">
                  <b-form-datepicker v-model="filter.fromDate" :locale="filter.locale" :date-format-options="filter.dateFormatOptions" :start-weekday="1" style="width: 200px;"/>
                </b-form-group>
                <b-form-group label="Đến ngày" label-for="to_date">
                  <b-form-datepicker v-model="filter.toDate" :locale="filter.locale" :date-format-options="filter.dateFormatOptions" :start-weekday="1" style="width: 200px;"/>
                </b-form-group>
                <div class="d-block d-md-flex align-items-center justify-content-around pt-2" style="width: 220px">
                  <b-button class="mr-2 mr-md-0" :variant="'primary'" @click="ScanSelected" :disabled="socketAvailable === false || scanningAccount.length > 0" id="buttonScan"><i :class="{'las': true, 'la-play': scanningAccount.length === 0, 'la-mug-hot': scanningAccount.length > 0}"/> Quét</b-button>
                  <b-button :variant="'primary'" @click="SaveSelected" :disabled="socketAvailable === false || successScanAccount.length === 0 || scanningAccount.length > 0" id="buttonSaveReport"><i class="las la-save"/> Lưu báo cáo</b-button>
                </div>
              </b-col>
            </b-row>
            <b-row class="mt-3 px-2">
              <b-col md="12">
                <iq-card v-show="scanningAccount.length > 0" style="background-color: #C4EAFF">
                  <template v-slot:headerTitle>
                    <b>Tiến độ</b>
                  </template>
                  <template v-slot:body>
                    <b-row class="px-2">
                      <b-col sm="4" v-for="c in scanningAccount" :key="`scanning-${c.account_id}`">
                        <b>{{c.display.username}}</b>: <span class="text-red">{{c._message}}</span>
                      </b-col>
                    </b-row>
                  </template>
                </iq-card>
              </b-col>
            </b-row>
            <b-row class="mt-3 px-2">
              <b-col>
                <iq-card v-show="scanningAccount.length > 0 || emptyScanAccount.length > 0" style="background-color: #DCFFCF">
                  <template v-slot:headerTitle>
                    <b>Tài khoản không có dữ liệu</b>
                  </template>
                  <template v-slot:body>
                      <b-col lg="12" v-for="c in emptyScanAccount" :key="`empty-${c.account_id}`">
                        <i @click="removeEmptyOrFailAccount('empty',c.account_id, c.display.username)" class="las la-trash-alt text-red"></i>
                        <b>{{c.display.username}}</b>: <span class="text-red">{{c._message}}</span>
                      </b-col>
                  </template>
                </iq-card>
              </b-col>
              <b-col>
                <iq-card v-show="scanningAccount.length > 0 || failScanAccount.length > 0" style="background-color: #FFEDCF">
                  <template v-slot:headerTitle>
                    <b>Tài khoản đăng nhập thất bại</b>
                  </template>
                  <template v-slot:body>
                    <b-col lg="12" v-for="c in failScanAccount" :key="`fail-${c.account_id}`">
                      <i v-b-modal.account-editor-modal @click="editAccountObject = {
                          network_id: c.network_id,
                          username: c.display.username,
                          id: c.account_id
                        }" class="las la-pen-alt text-yellow"></i>
                      <i @click="removeEmptyOrFailAccount('fail',c.account_id, c.display.username)" class="las la-trash-alt text-red"></i>
                        <b>{{c.display.username}}</b>: <span class="text-red">{{c._message}}</span>
                      </b-col>
                  </template>
                  <template v-slot:footer v-show="failScanAccount.length > 0">
                    <b-button variant="primary" @click="RescanFailedAccount()" :disabled="scanningAccount.length > 0">Quét lại</b-button>
                  </template>
                </iq-card>
              </b-col>
            </b-row>
            <b-row class="px-2">
              <b-col>
                <b-row>
                  <b-form-checkbox class="report-checkbox" @change="topCheckboxCheckAll($event)" :checked="allGroupCheck" style="margin-left:10px; margin-bottom: 10px;"><b>TẤT CẢ</b></b-form-checkbox>
                </b-row>
                <b-row v-for="(network, groupIndex) in networks" :key="`${network.id}`">
                  <iq-card class="col px-0">
                    <template v-slot:headerTitle>
                      <b-form-checkbox class="report-checkbox" @change="topCheckboxCheck(groupIndex, $event)" :checked="topGroupCheck[groupIndex]" :key="`${network.id}`">{{network.name}}</b-form-checkbox>
                      <b-button class="auto-report-add-account" size="sm" variant="primary" @click="selectedNetworkId = network.id" v-b-modal.account-creator-modal>Thêm tài khoản</b-button>
                    </template>
                    <template v-slot:body>
                      <b-row>
                        <b-col class="col-12 overflow-table-wrapper" v-for="(acc, checkIndex) in c_accountsInNetwork[network.id]" :key="`account-${network.id}-${acc.id}`">
                          <b-form-group>
                            <b-form-checkbox :checked="inGroupCheck[groupIndex][checkIndex]" @change="checkboxChange(groupIndex, checkIndex, $event)">
                              {{acc.username}}
                            </b-form-checkbox>
                          </b-form-group>
                          <b-table-simple small bordered v-if="successScanAccount.indexOf(acc.id) > -1 && successParseData['n'+acc.id]" :class="{'loadChild':loadingChildStatus['n'+acc.id]}">
                            <div class="loadChildElement-backdrop">
                              <div class="loadChildElement">
                                  <b-icon icon="gear-fill" animation="spin" font-scale="5"/>
                              </div>
                            </div>
                            <b-thead>
                              <b-tr>
                                <b-th>Tài khoản</b-th>
                                <b-th class="text-center">Loại</b-th>

                                <!-- CUSTOM FIELDS -->
                                <b-th class="text-right"
                                      v-for="field in successParseData['n'+acc.id][0]['ui_fields']"
                                      :key="field">
                                  {{field | removeDashField }}
                                </b-th>

                                <b-th width="200px">Công thức</b-th>
                                <b-th>Thành viên</b-th>
                                <b-th class="text-center" width="100px">Kết quả</b-th>
                                <b-th class="text-center" width="34px">Loại</b-th>
                                <b-th class="text-center" colspan="2">+/- CT</b-th>
                              </b-tr>
                            </b-thead>
                            <b-tbody v-for="(sc, accountIndex) in successParseData['n'+acc.id]" :key="sc['self']['id']">
                              <input type="hidden" :value="forceUpdate">
                              <template v-for="(category, category_index) in Object.entries(sc['ui_data'])">
                                <template v-for="(node, node_index) in category[1]">
<!--                                  CASE EMTPY -->
                                  <template v-if="node['formulas'].length === 0">
                                    <b-tr :key="`${sc['self']['id']}-${category_index}-${node_index}`">
                                      <b-td v-show="category_index === 0 " :index="category_index" :rowspan="sc['rowspan']" class="align-middle">
                                        <div class="report-customer-name" :style="{marginLeft: `${sc['current_level'] * 10}px` }">

                                          <a href="javascript:void(0)" v-show="sc['empty_status'] === false">
                                            <i :class="{
                                                'las': true,
                                                'la-caret-square-down': sc['dropdown_status'] === true,
                                                'la-caret-square-right': sc['dropdown_status'] === false,
                                                'dropdownbox-active': sc['dropdown_status'] === true,
                                                'd-none': sc['opening_status'] === true
                                            }" @click="toggleChild(sc['self']['id'], acc.id, sc['current_level'])"/>
                                            <b-icon v-show="sc['opening_status']" :key="`b-icon-${sc['self']['id']}`" icon="gear-wide" animation="spin" font-scale="1"/>
                                          </a>
                                          <a href="javascript:void(0)" v-show="sc['empty_status'] === true">
                                            <i class="las la-recycle" @click="toggleChild(sc['self']['id'], acc.id, sc['current_level'])"/>
                                          </a>
                                          <span>
                                            {{ sc['self']['cust_name'] }}
                                            <i v-show="accountIndex == 0" class="las la-recycle" @click="reloadAllChild(sc['self']['id'], acc.id, sc['current_level'])"/>
                                          </span>
                                        </div>
                                      </b-td>
                                      <b-td class="align-middle text-center" :rowspan="1">
                                        {{ category[0].toUpperCase() }}
                                      </b-td>
                                      <b-td v-for="field in sc['ui_fields']" :key="field" class="align-middle text-right">
                                        <span v-if="node[field] != undefined">
                                          {{ node[field] | numberFormat }}
                                        </span>
                                      </b-td>
                                      <b-td class="text-center" colspan="5">
                                        Chưa có công thức
                                      </b-td>
                                      <b-td v-show="category_index === 0" colspan="1" :rowspan="sc['rowspan']" class="text-center align-middle">
                                        <i class="text-green las la-plus-circle" v-b-modal.attach-link-modal @click="updateSelectedAccount(sc)"></i>
                                      </b-td>
                                    </b-tr>
                                  </template>
<!--                                  CASE HAVE FORMULAS -->
                                  <template v-if="node['formulas'].length > 0">
                                    <b-tr v-for="(formular, formular_index) in node['formulas']" :key="`member-formula-${category[0]}-${formular.member_id}-${formular.id}`">
                                      <b-td v-show="category_index === 0 && formular_index === 0" :index="category_index" :rowspan="sc['rowspan']" class="align-middle">
                                        <div class="report-customer-name" :style="{marginLeft: `${sc['current_level'] * 10}px` }">
                                        <a href="javascript:void(0)" v-if="sc['empty_status'] === false">
                                          <i :class="{
                                            'las': true,
                                            'la-caret-square-down': sc['dropdown_status'] === true,
                                            'la-caret-square-right': sc['dropdown_status'] === false,
                                            'dropdownbox-active': sc['dropdown_status'] === true,
                                            'd-none': sc['opening_status'] === true
                                          }" v-show="sc['self']['ajax_child'] !== '0'" @click="toggleChild(sc['self']['id'], acc.id, sc['current_level'])"/>
                                          <b-icon v-show="sc['opening_status']" :key="`b-icon-${sc['self']['id']}`" icon="gear-wide" animation="spin" font-scale="1"/>
                                        </a>
                                        <a href="javascript:void(0)" v-show="sc['empty_status'] === true">
                                          <i class="las la-recycle" @click="toggleChild(sc['self']['id'], acc.id, sc['current_level'])"/>
                                        </a>
                                        <span>
                                          {{ sc['self']['cust_name'] }}
                                          <i v-show="accountIndex == 0" class="las la-recycle" @click="reloadAllChild(sc['self']['id'], acc.id, sc['current_level'])"/>
                                        </span>
                                        </div>
                                      </b-td>
                                      <b-td v-show="formular_index === 0" :rowspan="node['formulas'].length"  :index="formular_index" class="align-middle text-center">
                                        {{ category[0].toUpperCase() }}
                                      </b-td>

                                      <b-td v-show="formular_index === 0" :rowspan="node['formulas'].length" v-for="field in sc['ui_fields']" :key="field" class="align-middle text-right">
                                        <span v-if="node && node[field] != undefined">
                                          {{ node[field] | numberFormat }}
                                        </span>
                                      </b-td>

                                      <b-td :style="{backgroundColor: formular.color}">
                                        <div style="min-width: 150px;">{{ formular.name }}</div>
                                      </b-td>
                                      <b-td>
                                        <div style="min-width: 100px;">{{ formular.member_name }}</div>
                                      </b-td>

                                      <b-td class="p-0" colspan="2">
                                          <table class="w-100">
                                            <tbody>
                                                <fragment v-for="(r, index) in formular.results" :key="`${formular.member_id} - ${formular.id} - ${r.currency} - ${index}`">
                                                    <b-tr class="row-mini-result-table">
                                                      <b-td class="text-right">
                                                        <span :class="{'text-green': r.result.indexOf('-') === -1, 'text-red': r.result.indexOf('-') > -1}">{{ r.result }}</span>
                                                      </b-td>
                                                      <b-td class="text-center w-25">
                                                        <span :class="{'text-green': r.result.indexOf('-') === -1, 'text-red': r.result.indexOf('-') > -1}">{{ r.currency }}</span>
                                                      </b-td>
                                                    </b-tr>
                                                </fragment>
                                              </tbody>
                                          </table>
                                      </b-td>

                                      <b-td class="align-middle text-center">
                                        <a href="javascript:void (0)"><i class="text-red las la-minus-circle" @click="removeFormula(formular, sc)"></i></a>
                                      </b-td>
                                      <b-td v-show="category_index === 0 && formular_index === 0" :rowspan="sc['rowspan']" class="text-center align-middle">
                                        <i class="text-green las la-plus-circle" v-b-modal.attach-link-modal @click="updateSelectedAccount(sc)"></i>
                                      </b-td>
                                    </b-tr>
                                  </template>
                                </template>
                              </template>
                            </b-tbody>
                          </b-table-simple>
                        </b-col>
                      </b-row>
                    </template>
                  </iq-card>
                </b-row>
              </b-col>
            </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-modal id="attach-link-modal" title="Gán công thức" ok-title="Xác nhận" cancel-title="Đóng" size="lg">
      <template #modal-header>
        <h4>Gán công thức</h4>
      </template>
      <template #default>
        <link-attach :input-account-id="selectedAccount['self']['id'].toString()" :network-id="selectedAccount['networkId']" v-on:created-link="newLinkCreated" v-on:removed-link="justLinkRemoved"/>
      </template>
      <template #modal-footer>
        <b-button variant="default" @click="$bvModal.hide('attach-link-modal')">Đóng</b-button>
      </template>
    </b-modal>

    <account-create-modal modal-id="account-creator-modal" :network-id="selectedNetworkId" />
    <account-editor-modal modal-id="account-editor-modal" :object-edit="editAccountObject"/>

  </b-container>
</template>

<script>
import { findash } from '../../config/pluginInit'
import Vue from 'vue'
import moment from 'moment'
import timezone from 'moment-timezone'
import { mapActions, mapGetters } from 'vuex'
import _ from 'lodash'
import api from '../../store/api'
import LinkAttach from '../../components/application/link/LinkAttach'
import AccountEditorModal from '@/components/application/account/AccountEditorModal'
import AccountCreateModal from '@/components/application/account/AccountCreateModal'

export default {
  name: 'AutoReport',
  components: {
    LinkAttach,
    AccountEditorModal,
    AccountCreateModal
  },
  sockets: {
    connect: function () {
      console.log('Begin Sockets connect')
    },
    customEmit: function (data) {
      console.log('this method was fired by the socket server. eg: io.emit("customEmit", data)')
    },
    success: function (msg) {
      console.log('Socket connect successful')
      this.socketAvailable = true
    },
    error: function (msg) {
      console.error(`Error ${msg}`)
    },
    scan_success: function (msg) {
      this.emittingScanningAccount--
      let mainAccountId = msg.fe_data['main_account_id']
      let isMainAccount = msg.fe_data['is_main_account']
      let theIndex = this.getScanningIndex(mainAccountId)

      if (this.loadingChildStatus['n' + mainAccountId]) {
        this.loadingChildStatus['n' + mainAccountId] = false
      }
      // because of setTimeout so we need get theIndex again
      theIndex = this.getScanningIndex(mainAccountId)
      // add to empty scanning array before removing
      if (this.scanningAccount[theIndex] && msg.data) {
        let isEmpty = true
        let networkId = this.scanningAccount[theIndex].network_id
        let indexToPut = this.findIndexFromFeData(msg.fe_data)

        // loop though data to get empty
        _.each(msg.data, (category) => {
          if (Array.isArray(category) && category.length > 0) {
            isEmpty = false
            // skip if error come from child accounts
            if (msg.fe_data && msg.fe_data['emit_from_account_id']) {
              this.forceUpdate++
            }
          }
        })

        if (isEmpty) {
          if (isMainAccount) {
            this.emptyScanAccount.push(_.extend(this.scanningAccount[theIndex], { _message: `Không dữ liệu` }))
          }
          if (this.successParseData['n' + mainAccountId] && this.successParseData['n' + mainAccountId][indexToPut]) {
            this.successParseData['n' + mainAccountId][indexToPut]['empty_status'] = true
            this.successParseData['n' + mainAccountId][indexToPut]['dropdown_status'] = false
          }
          this.removeFromScanning(mainAccountId)
          this.forceUpdate++
        } else {
          if (this.scanningAccount[theIndex]) { Vue.set(this.scanningAccount, theIndex, _.extend(this.scanningAccount[theIndex], { _message: 'Đang phân tích' })) }

          try {
            if (msg.fe_data['is_main_account']) {
              api.report.scan({
                'account_id': msg.account_id,
                'data': JSON.stringify(msg.data)
              }).then((res) => {
                let sortReponse = this.sortResByCustName(res, 'asc')
                this.successScanAccount.push(msg.account_id)
                this.parseDataAfterScan(sortReponse, msg.account_id, networkId, msg)
                if (this.scanningAccount[theIndex]) { Vue.set(this.scanningAccount, theIndex, _.extend(this.scanningAccount[theIndex], { _message: 'Đang check downline' })) }
                this.continueScanAccount(sortReponse, msg)
                // this.forceUpdate++
              })

              if (this.successParseData['n' + mainAccountId]) {
                this.successParseData['n' + mainAccountId][0]['opening_status'] = false
              }
            } else {
              api.report.scanMixChild({
                'account_id': msg.account_id,
                'data': JSON.stringify(msg.data)
              }).then((res) => {
                let sortReponse = this.sortResByCustName(res)
                this.successScanAccount.push(msg.account_id)
                this.parseDataAfterScan(sortReponse, msg.account_id, networkId, msg)
                if (this.scanningAccount[theIndex]) { Vue.set(this.scanningAccount, theIndex, _.extend(this.scanningAccount[theIndex], { _message: 'Đang check downline' })) }
                this.continueScanAccount(sortReponse, msg)
                // this.forceUpdate++
              })
            }
          } catch (e) {
            console.error(`Parse error ${theIndex}:` + e.message)
            if (this.scanningAccount[theIndex]) { this.failScanAccount.push(_.extend(this.scanningAccount[theIndex], { _message: `Parse lỗi ${e.message}` })) }
          }
        }

        if (indexToPut > -1 && this.successParseData['n' + mainAccountId][indexToPut]) {
          this.successParseData['n' + mainAccountId][indexToPut]['opening_status'] = false
        }
      } else {
        console.error('Lỗi')
      }
    },
    scan_step: function (msg) {
      let mainAccountId = msg.fe_data['main_account_id']
      let theIndex = this.getScanningIndex(mainAccountId)

      Vue.set(this.scanningAccount, theIndex, _.extend(this.scanningAccount[theIndex], { _message: msg.message }))
    },
    scan_error: function (msg) {
      this.emittingScanningAccount--
      let mainAccountId = msg.fe_data['main_account_id']
      let theIndex = this.getScanningIndex(mainAccountId)

      if (this.loadingChildStatus['n' + mainAccountId]) {
        this.loadingChildStatus['n' + mainAccountId] = false
      }

      // skip if error come from child accounts
      if (msg.fe_data && msg.fe_data['emit_from_account_id']) {
        let indexToPut = this.findIndexFromFeData(msg.fe_data)

        this.successParseData['n' + mainAccountId][indexToPut]['opening_status'] = false
        this.forceUpdate++

        return
      }

      if (this.scanningAccount[theIndex]) {
        // add to error scanning array before removing
        this.failScanAccount.push(_.extend(this.scanningAccount[theIndex], { _message: msg.message }))

        this.scanningAccount.splice(theIndex, 1)
      }
    }
  },
  created () {
    timezone.tz.setDefault('Asia/Ho_Chi_Minh')

    this.onInit()

    let maxScan = parseInt(process.env.VUE_APP_MAX_SCAN)
    setInterval(() => {
      if (this.stackWaitingEmitAccount.length === 0) return
      if (this.emittingScanningAccount > maxScan) return

      let loopCount = parseInt(process.env.VUE_APP_MAX_SCAN) - this.emittingScanningAccount

      if (loopCount > 0) {
        for (let x = 0; x < loopCount; x++) {
          // check length after shifting
          if (this.stackWaitingEmitAccount.length > 0) {
            let firstInStack = this.stackWaitingEmitAccount.shift()
            if (firstInStack) {
              this.emittingScanningAccount++
              this.$socket.emit(firstInStack['socketEvent'], firstInStack['dataScan'])
            }
          }
        }
      }
    }, 100)
  },
  async mounted () {
    findash.index()
    if (this.authUser.token) {
      // update query
      this.$socket.io.opts.query = {
        auth_token: this.authUser.token
      }

      await this.$socket.open()

      this.$socket.on('connect_error', (e) => {
        console.error('Socket connect_error: ' + e.message)
        // make all scanning account to
        this.actionOnSocketFail()
      })
    }
  },
  beforeDestroy () {
    this.$socket.close()
    this.actionUnsubcribeEventSocket()

    this.updateSelectedAccount(null)
  },
  data () {
    return {
      filter: {
        locale: 'vi',
        dateFormatOptions: { year: 'numeric', month: 'numeric', day: 'numeric', weekday: 'long' },
        fromDate: new Date(),
        toDate: new Date()
      },
      socketAvailable: false,
      allGroupCheck: false,
      topGroupCheck: [],
      inGroupCheck: [],
      inGroupAccountId: [],
      scanningAccount: [],
      emittingScanningAccount: 0,
      stackWaitingEmitAccount: [],
      failScanAccount: [],
      emptyScanAccount: [],
      successScanAccount: [],
      successParseData: [],
      loadingChildStatus: [], // using to display loading when continueScanAccount
      currentNetworkCustomFields: [],
      forceUpdate: 1,
      editAccountObject: null,
      selectedNetworkId: null,
      optionalDataScan: {}
    }
  },
  computed: {
    ...mapGetters({
      'accounts': 'Account/listState',
      'networks': 'Network/listState',
      'serverError': 'Setting/serverErrorsState',
      'serverRequesting': 'Setting/serverRequestingState',
      'authUser': 'Auth/authUserState',
      'selectedAccount': 'Report/autoReportSelectedAccount'
    }),
    c_accountsInNetwork: function () {
      return _.groupBy(_.map(_.filter(this.accounts, (e) => {
        return e.parent_id === '0'
      })), 'network_id')
    }
  },
  watch: {
    networks: function (newVal, oldVal) {
      this.onInit()
    },
    accounts: function (newVal, oldVal) {
      this.onInit()
    }
  },
  methods: {
    onInit () {
      let initChoose = false
      if (this.accounts.length > 0 && this.networks.length > 0) {
        _.each(this.networks, (network, nIndex) => {
          if (this.inGroupCheck[nIndex] === undefined) {
            this.inGroupCheck[nIndex] = []
            this.inGroupAccountId[nIndex] = []
            this.topGroupCheck[nIndex] = this.topGroupCheck[nIndex] ?? initChoose
          }

          _.each(this.c_accountsInNetwork[network.id], (acc, aIndex) => {
            this.inGroupCheck[nIndex][aIndex] = this.inGroupCheck[nIndex][aIndex] ?? initChoose
            this.inGroupAccountId[nIndex][aIndex] = acc
          })
        })
      }
    },
    onSubmit () {
    },
    reRenderAllCheckBox: function () {
      let checkedStatus = true

      if (this.inGroupCheck.length === 0) {
        checkedStatus = false
      }
      for (let x = 0; x < this.inGroupCheck.length; x++) {
        for (let y = 0; y < this.inGroupCheck[x].length; y++) {
          if (this.inGroupCheck[x][y] === false) {
            checkedStatus = false
          }
        }
      }

      this.allGroupCheck = checkedStatus
    },
    filter_date (choice) {
      this.filter.date = choice

      let vietnamTime = moment().utc().add(7, 'hours')

      switch (choice) {
        case 1:
          this.filter.fromDate = moment(vietnamTime).format('YYYY-MM-DD HH:mm:ss')
          this.filter.toDate = moment(vietnamTime).format('YYYY-MM-DD HH:mm:ss')
          break
        case 2:
          this.filter.fromDate = moment(vietnamTime).subtract(1, 'day').startOf('date').format('YYYY-MM-DD HH:mm:ss')
          this.filter.toDate = moment(vietnamTime).subtract(1, 'day').endOf('date').format('YYYY-MM-DD HH:mm:ss')
          break
        case 3:
          if (moment(vietnamTime).hours() < 12 && moment(vietnamTime).weekday() === 1) {
            this.filter.fromDate = moment(vietnamTime).subtract(1, 'week').startOf('isoWeek').format('YYYY-MM-DD HH:mm:ss')
            this.filter.toDate = moment(vietnamTime).subtract(1, 'week').endOf('isoWeek').format('YYYY-MM-DD HH:mm:ss')
          } else {
            this.filter.fromDate = moment(vietnamTime).startOf('isoWeek').format('YYYY-MM-DD HH:mm:ss')
            this.filter.toDate = moment(vietnamTime).endOf('isoWeek').format('YYYY-MM-DD HH:mm:ss')
          }
          break
        case 4:
          if (moment(vietnamTime).hours() < 12 && moment(vietnamTime).weekday() === 1) {
            this.filter.fromDate = moment(vietnamTime).subtract(2, 'week').startOf('isoWeek').format('YYYY-MM-DD HH:mm:ss')
            this.filter.toDate = moment(vietnamTime).subtract(2, 'week').endOf('isoWeek').format('YYYY-MM-DD HH:mm:ss')
          } else {
            this.filter.fromDate = moment(vietnamTime).subtract(1, 'week').startOf('isoWeek').format('YYYY-MM-DD HH:mm:ss')
            this.filter.toDate = moment(vietnamTime).subtract(1, 'week').endOf('isoWeek').format('YYYY-MM-DD HH:mm:ss')
          }
          break
      }
    },
    topCheckboxCheckAll (value) {
      if (value) {
        // check all the top group checks
        for (let x = 0; x < this.topGroupCheck.length; x++) {
          this.topGroupCheck.splice(x, 1, true)
        }

        // check all the account checks
        for (let x = 0; x < this.inGroupCheck.length; x++) {
          for (let y = 0; y < this.inGroupCheck[x].length; y++) {
            this.inGroupCheck[x].splice(y, 1, true)
          }
        }
      } else {
        // uncheck all the Top Checks
        for (let x = 0; x < this.topGroupCheck.length; x++) {
          this.topGroupCheck.splice(x, 1, false)
        }

        // uncheck all the account checks
        for (let x = 0; x < this.inGroupCheck.length; x++) {
          for (let y = 0; y < this.inGroupCheck[x].length; y++) {
            this.inGroupCheck[x].splice(y, 1, false)
          }
        }
      }

      this.reRenderAllCheckBox()
      this.forceUpdate++
    },
    topCheckboxCheck (groupIndex, value) {
      // cheat the way to force render by trigger render by updating something could trigger the UI to update
      this.topGroupCheck.splice(groupIndex, 1, value)

      if (value === false) {
        for (let x = 0; x < this.inGroupCheck[groupIndex].length; x++) {
          this.inGroupCheck[groupIndex].splice(x, 1, false)
        }
      } else if (value === true) {
        for (let x = 0; x < this.inGroupCheck[groupIndex].length; x++) {
          this.inGroupCheck[groupIndex].splice(x, 1, true)
        }
      }

      this.reRenderAllCheckBox()
      this.forceUpdate++
    },
    checkboxChange (groupIndex, checkIndex, value) {
      // this not trigger to render the view, dont know why, so we have to change topGroupCheck by using shallow copy methoh
      this.inGroupCheck[groupIndex][checkIndex] = value

      let isAnyUnChecked = _.filter(this.inGroupCheck[groupIndex], (e) => {
        return e === false
      }).length > 0

      // all checked
      if (isAnyUnChecked === true) {
        this.topGroupCheck.splice(groupIndex, 1, false)
      } else {
        this.topGroupCheck.splice(groupIndex, 1, true)
      }

      this.reRenderAllCheckBox()
      this.forceUpdate++
    },
    waitMainAccountScan (mainAccountId, cb) {
      let loadingChildStatus = false
      let theInterval = null
      theInterval = setInterval(() => {
        loadingChildStatus = this.loadingChildStatus['n' + mainAccountId]
        if (loadingChildStatus === false) {
          clearInterval(theInterval)
          cb && cb()
        }
      }, 50)
    },
    waitSubAccountScan (mainAccountId, indexToOpen) {
      let theInverval = null
      let node = null
      let loadingChildStatus = false
      return new Promise((resolve, reject) => {
        theInverval = setInterval(() => {
          node = this.successParseData['n' + mainAccountId][indexToOpen]
          loadingChildStatus = this.loadingChildStatus['n' + mainAccountId]

          if (node === undefined) {
            clearInterval(theInverval)
            reject(new Error('waitSubAccountScan: node is undefined'))
          } else {
            if (node['opening_status'] === false && loadingChildStatus === false) {
              clearInterval(theInverval)
              resolve()
            }
          }
        }, 50)
      })
    },
    waitSocketSubmit (socketEvent, dataScan, skipAddScanning = false) {
      dataScan._message = 'Chờ quét'
      if (skipAddScanning === false) {
        this.scanningAccount.push(dataScan)
      }

      this.stackWaitingEmitAccount.push({
        'socketEvent': socketEvent,
        'dataScan': dataScan,
        'account_id': dataScan['fe_data']['main_account_id']
      })
    },
    async ScanSelected (event, failAccounts = []) {
      // DRY: code block to reset everything before scanning
      this.scanningAccount = []
      this.stackWaitingEmitAccount = []
      this.emittingScanningAccount = 0
      this.failScanAccount = []

      this.optionalDataScan = {}

      // when rescan dont reset anything already success
      if (failAccounts.length === 0) {
        this.emptyScanAccount = []
        this.successScanAccount = []
        this.successParseData = []
        this.loadingChildStatus = []
        this.currentNetworkCustomFields = []
      }

      // networks loop
      for (let nIndex = 0; nIndex < this.inGroupCheck.length; nIndex++) {
        // account loop
        for (let aIndex = 0; aIndex < this.inGroupCheck[nIndex].length; aIndex++) {
          if (this.inGroupCheck[nIndex][aIndex] === true) {
            let acc = this.inGroupAccountId[nIndex][aIndex]

            // when rescan dont need to reset
            if (failAccounts.length > 0) {
              let failIndex = _.findIndex(_.map(failAccounts, a => a.account_id), (e) => e === acc.id)
              if (failIndex === -1) {
                continue
              }
            }

            this.loadingChildStatus['n' + acc.id] = true

            let dataScan = {
              'account_id': acc.id,
              'network_id': acc.network_id,
              'display': {
                'username': acc.username
              },
              'from_date': moment(this.filter.fromDate).format('YYYY-MM-DD'), // yyyy-mm-dd
              'to_date': moment(this.filter.toDate).format('YYYY-MM-DD'), // yyyy-mm-dd,
              '_message': 'Đang xử lý',
              'fe_data': {
                'load_childs': acc.load_childs === '1',
                'is_main_account': true,
                'main_account_id': acc.id,
                'emit_from_level': 0,
                'emit_from_account_id': 0,
                'main_username': acc.username
              }
            }

            this.waitSocketSubmit('scan', dataScan)
          }
        }
      }
    },
    RescanFailedAccount () {
      // only scan failed accounts
      this.ScanSelected(null, this.failScanAccount)
    },
    SaveSelected () {
      let fromDate = moment(this.filter.fromDate).format('YYYY-MM-DD') // yyyy-mm-dd
      let toDate = moment(this.filter.toDate).format('YYYY-MM-DD') // yyyy-mm-dd
      let data = []
      let arrData = Object.entries(this.successParseData)

      _.each(arrData, (acc) => {
        let masterId = acc[0].replace('n', '')
        let account = acc[1]
        if (account !== undefined && account.length > 0) {
          data.push({
            id: masterId,
            data: _.uniqBy(_.flatten(_.map(account, (sd) => sd['submitData'])), 'id')
          })
        }
      })

      api.report.saveScanned(fromDate, toDate, data).then((res) => {
        this.$swal({
          icon: 'success',
          title: 'Lưu thành công'
        })
      }).catch(() => {
        this.$swal({
          icon: 'error',
          title: 'Lỗi...',
          text: this.serverError
        })
      })
    },
    getScanningIndex (accountId) {
      return _.findIndex(this.scanningAccount, (sc) => {
        return sc.account_id === accountId
      })
    },
    replaceNode (mainAccountId, node, dataPush) {
      let indexToReplace = this.findIndexToPut(mainAccountId, node['id'])

      // replace node but keep the state
      if (indexToReplace !== -1) {
        dataPush['dropdown_status'] = this.successParseData['n' + mainAccountId][indexToReplace]['dropdown_status'] || false
        dataPush['opening_status'] = this.successParseData['n' + mainAccountId][indexToReplace]['opening_status'] || false
        dataPush['empty_status'] = this.successParseData['n' + mainAccountId][indexToReplace]['empty_status'] || false
        dataPush['current_level'] = this.successParseData['n' + mainAccountId][indexToReplace]['current_level'] || 0

        Vue.set(this.successParseData['n' + mainAccountId], indexToReplace, dataPush)
      }
    },
    addNode (mainAccountId, emitFromAccountId, indexToPut, dataPush) {
      if (emitFromAccountId === 0) {
        this.successParseData['n' + mainAccountId].push(dataPush)
      } else {
        this.successParseData['n' + mainAccountId].splice(indexToPut + 1, 0, dataPush)
      }
    },
    sortResByCustName (res, direction = 'desc') {
      // sort DESC will make the Alphabet sort style (stack style)
      return _.orderBy(res, ['cust_name'], [direction])
    },
    parseDataAfterScan (res, accountId, networkId, msgData, replaceExisted = false) {
      let feData = msgData.fe_data
      let mainAccountId = feData['main_account_id']
      let emitFromLevel = feData['emit_from_level']
      let emitFromAccountId = feData['emit_from_account_id']
      let isMainAccount = feData['is_main_account']
      let isLoadChilds = feData['load_childs'] === undefined || feData['load_childs'] === true

      if (networkId === undefined) {
        // set default networkId is the first account
        networkId = this.successParseData['n' + mainAccountId][0]['networkId']
      }

      // get available fields
      let theNetwork = _.find(this.networks, (n) => {
        return n.id === networkId
      })

      let theMainAccount = _.find(this.accounts, (n) => {
        return n.id === mainAccountId
      })

      // parse to value to get the key
      let showType = theMainAccount.show_type

      // last element in array
      let returnDataByShowType = null
      let dataByShowType = null
      let totalFormulas = 0
      let nextLevel = 0

      let arrNodes = _.values(res)

      let parentNode = null
      let childNodes = []

      _.each(arrNodes, (node) => {
        let haveChildren = _.findIndex(arrNodes, (n) => { return n['parent_id'] === node['id'] }) > -1

        if (node['id'] && haveChildren) {
          parentNode = node
        } else {
          if (isLoadChilds) {
            childNodes.push(node)
          }
        }
      })

      if (this.successParseData['n' + mainAccountId] === undefined) {
        this.successParseData['n' + mainAccountId] = []
        this.currentNetworkCustomFields['n' + mainAccountId] = theNetwork ? theNetwork.display : []
      }

      let dataPush = null
      let indexToPut = 0

      indexToPut = this.findIndexToPut(mainAccountId, emitFromAccountId)

      if (parentNode) {
        returnDataByShowType = this.getDataByShowType(showType, parentNode)
        dataByShowType = returnDataByShowType[0]
        totalFormulas = returnDataByShowType[1]

        nextLevel = emitFromLevel + 1
        // put the parent
        dataPush = {
          'self': parentNode,
          'networkId': networkId,
          'mainAccountId': mainAccountId,
          'msgData': msgData,
          'submitData': res,
          'emittedFromRoot': isMainAccount,
          'ui_fields': this.currentNetworkCustomFields['n' + mainAccountId],
          'ui_data': dataByShowType,
          'rowspan': totalFormulas || 1,
          'current_level': nextLevel,
          'dropdown_status': isLoadChilds,
          'opening_status': false,
          'empty_status': false
        }

        if (replaceExisted) {
          this.replaceNode(mainAccountId, parentNode, dataPush)
        } else if (!this.checkExistBeforeCommit(mainAccountId, parentNode['id'])) {
          this.addNode(mainAccountId, emitFromAccountId, indexToPut, dataPush)
        }
      }
      // put the children
      if (childNodes.length > 0) {
        nextLevel = emitFromLevel + 2
        for (let x = 0; x < childNodes.length; x++) {
          let node = childNodes[x]
          returnDataByShowType = this.getDataByShowType(showType, node)
          dataByShowType = returnDataByShowType[0]
          totalFormulas = returnDataByShowType[1]

          dataPush = {
            'self': node,
            'networkId': networkId,
            'mainAccountId': mainAccountId,
            'msgData': msgData,
            'submitData': res,
            'emittedFromRoot': isMainAccount,
            'ui_fields': this.currentNetworkCustomFields['n' + mainAccountId],
            'ui_data': dataByShowType,
            'rowspan': totalFormulas || 1,
            'current_level': nextLevel,
            'dropdown_status': false,
            'opening_status': false,
            'empty_status': false
          }

          if (replaceExisted) {
            this.replaceNode(mainAccountId, node, dataPush)
          } else if (!this.checkExistBeforeCommit(mainAccountId, node['id'])) {
            this.addNode(mainAccountId, emitFromAccountId, indexToPut, dataPush)
          }
        }
      }

      // open status on parent account
      if (indexToPut > -1 && childNodes.length > 0) {
        if (indexToPut > -1 && childNodes.length > 0) {
          this.successParseData['n' + mainAccountId][indexToPut]['dropdown_status'] = true
          this.successParseData['n' + mainAccountId][indexToPut]['opening_status'] = false
        }
      }
    },
    checkExistBeforeCommit (mainAccountId, commitAccountId) {
      let mapData = _.map(this.successParseData['n' + mainAccountId], (e) => {
        return e['self']['id']
      })
      let result = false
      for (let x = 0; x < mapData.length; x++) {
        if (mapData[x] === commitAccountId && result === false) {
          result = true
        }
      }
      return result
    },
    getDataByShowType (showType, node) {
      let dataByShowType = {}
      let totalFormulas = 0

      switch (showType) {
        case 'all':
          dataByShowType['all'] = [
            node['all']
          ]

          if (node['all']['formulas'] && node['all']['formulas'].length) {
            _.each(node['all']['formulas'], (e) => {
              totalFormulas += e.results ? e.results.length : 1
            })
          } else {
            totalFormulas += 1
          }

          break
        case 'detail':
          _.each([
            'sb',
            'loto',
            'csn',
            'soft',
            'ga_cam',
            'ga_phi',
            'sexy',
            'venus',
            'keno',
            'racing',
            'lasvegas',
            'games_xs',
            'csn789',
            'loto789',
            'horse'
          ]
          , (existField) => {
            if (node[existField] !== undefined) {
              if (dataByShowType[existField] === undefined) {
                dataByShowType[existField] = []
              }
              dataByShowType[existField].push(node[existField])

              if (node[existField]['formulas'] && node[existField]['formulas'].length > 0) {
                _.each(node[existField]['formulas'], (e) => {
                  totalFormulas += e.results ? e.results.length : 1
                })
              } else {
                totalFormulas += 1
              }
            }
          })
          break
      }

      return [dataByShowType, totalFormulas]
    },
    findIndexToPut (mainAccountId, emitFromAccountId) {
      let indexToPut = _.findIndex(this.successParseData['n' + mainAccountId], (e) => {
        return e['self']['id'].toString() === emitFromAccountId.toString()
      })

      return indexToPut
    },
    findIndexFromFeData (feData) {
      let mainAccountId = feData['main_account_id']
      let emitFromAccountId = feData['emit_from_account_id']

      return this.findIndexToPut(mainAccountId, emitFromAccountId)
    },
    findMainAccountData (mainAccountId) {
      let indexToPut = _.findIndex(this.successParseData['n' + mainAccountId], (e) => {
        return e['self']['id'] === mainAccountId
      })

      return this.successParseData['n' + mainAccountId][indexToPut]
    },
    async reloadAllChild (emitFromAccountId, mainAccountId, emitFromLevel) {
      let indexToPut = this.findIndexToPut(mainAccountId, emitFromAccountId)
      this.closeChild(indexToPut, emitFromAccountId, mainAccountId)
      this.optionalDataScan = { reload_data: true }
      this.openChild(indexToPut, emitFromAccountId, mainAccountId, emitFromLevel)

      this.successParseData['n' + mainAccountId][indexToPut]['dropdown_status'] = true
      this.forceUpdate++
    },
    closeChild (indexToPut, emitFromAccountId, mainAccountId) {
      // close
      // check next index until get the next parent with same level
      let currentLevel = this.successParseData['n' + mainAccountId][indexToPut]['current_level']

      let flagStop = false
      let removeIndexes = []

      for (let x = indexToPut + 1; x < this.successParseData['n' + mainAccountId].length; x++) {
        let node = this.successParseData['n' + mainAccountId][x]

        if (flagStop === false) {
          if (currentLevel === node['current_level']) {
            flagStop = true
          } else {
            removeIndexes.push(x)
          }
        }
      }

      if (removeIndexes.length > 0) {
        this.successParseData['n' + mainAccountId] = _.filter(this.successParseData['n' + mainAccountId], (node, index) => {
          return removeIndexes.indexOf(index) === -1
        })
      }

      this.successParseData['n' + mainAccountId][indexToPut]['dropdown_status'] = false
    },
    openChild (indexToPut, emitFromAccountId, mainAccountId, emitFromLevel) {
      // open
      let newVal = this.successParseData['n' + mainAccountId][indexToPut]
      newVal['opening_status'] = true

      Vue.set(this.successParseData['n' + mainAccountId], indexToPut, newVal)

      this.loadingChildStatus['n' + mainAccountId] = true

      let dataScan = {}

      if (newVal['emittedFromRoot'] && newVal['self']['id'] === mainAccountId) {
        dataScan = _.merge({
          'account_id': mainAccountId,
          'network_id': newVal['self']['network_id'],
          'display': {
            'username': newVal['self']['cust_name'] // display scanning account by main account name
          },
          'from_date': moment(this.filter.fromDate).format('YYYY-MM-DD'), // yyyy-mm-dd
          'to_date': moment(this.filter.toDate).format('YYYY-MM-DD'), // yyyy-mm-dd
          'fe_data': {
            'is_main_account': true,
            'main_account_id': mainAccountId,
            'emit_from_level': 0,
            'emit_from_account_id': 0,
            'main_username': null
          }
        }, this.optionalDataScan)
        this.waitSocketSubmit('scan', dataScan)
      } else {
        dataScan = _.merge({
          'account_id': emitFromAccountId,
          'network_id': newVal['self']['network_id'],
          'display': {
            'username': newVal['self']['cust_name'] // display scanning account by main account name
          },
          'from_date': moment(this.filter.fromDate).format('YYYY-MM-DD'), // yyyy-mm-dd
          'to_date': moment(this.filter.toDate).format('YYYY-MM-DD'), // yyyy-mm-dd
          'fe_data': {
            'is_main_account': false,
            'main_account_id': mainAccountId,
            'emit_from_level': emitFromLevel,
            'emit_from_account_id': emitFromAccountId,
            'main_username': null
          }
        }, this.optionalDataScan)
        this.waitSocketSubmit('scan_child', dataScan, true)
      }

      this.successParseData['n' + mainAccountId][indexToPut]['dropdown_status'] = true
    },
    async toggleChild (emitFromAccountId, mainAccountId, emitFromLevel) {
      let indexToPut = this.findIndexToPut(mainAccountId, emitFromAccountId)

      if (indexToPut > -1) {
        if (this.successParseData['n' + mainAccountId][indexToPut] && this.successParseData['n' + mainAccountId][indexToPut]['dropdown_status'] === true) {
          // close
          this.closeChild(indexToPut, emitFromAccountId, mainAccountId)
        } else {
          this.openChild(indexToPut, emitFromAccountId, mainAccountId, emitFromLevel)
        }
      }

      this.forceUpdate++
    },
    removeFormula (formula, node) {
      let formulaId = formula.id
      let formulaType = formula.type_formula

      this.$swal({
        title: 'Xóa công thức',
        text: 'Bạn chắc chắn xóa công thức này ?',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Xóa',
        denyButtonText: `Hủy`
      }).then((result) => {
        if (result.isConfirmed) {
          switch (formulaType) {
            case 0:
              api.formular.deleteByAccount(formulaId).then(async () => {
                this.$swal({
                  icon: 'success',
                  title: 'Xóa thành công'
                })
                this.reloadFormulas(node)
              }).catch(() => {
                this.$swal({
                  icon: 'error',
                  title: 'Lỗi...',
                  text: this.serverError
                })
              })
              break
            case 1:
              api.formular.deleteComplexByAccount(formulaId).then(async () => {
                this.$swal({
                  icon: 'success',
                  title: 'Xóa thành công'
                })
                this.reloadFormulas(node)
              }).catch(() => {
                this.$swal({
                  icon: 'error',
                  title: 'Lỗi...',
                  text: this.serverError
                })
              })
              break
          }
        } else if (result.isDenied) {

        }
      })
    },
    reloadFormulas (node) {
      if (node['emittedFromRoot']) {
        // call scan mix
        api.report.scan({
          'account_id': node['mainAccountId'], // emit from root so we refresh from root
          'data': JSON.stringify(node['msgData'].data)
        }).then((res) => {
          let sortReponse = this.sortResByCustName(res, 'asc')
          this.parseDataAfterScan(sortReponse, node['mainAccountId'], node['networkId'], node['msgData'], true)
          this.forceUpdate++
        })
      } else {
        // call can mix child
        api.report.scanMixMe({
          'account_id': node['self']['id'],
          'data': JSON.stringify(node['msgData'].data)
        }).then((res) => {
          let sortReponse = this.sortResByCustName(res)
          this.parseDataAfterScan(sortReponse, node['self']['id'], node['networkId'], node['msgData'], true)
          this.forceUpdate++
        })
      }
    },
    newLinkCreated (res) {
      if (this.selectedAccount) { this.reloadFormulas(this.selectedAccount) }
    },
    justLinkRemoved () {
      if (this.selectedAccount) { this.reloadFormulas(this.selectedAccount) }
    },
    removeFromScanning (accountId) {
      let theIndex = this.getScanningIndex(accountId)

      // remove from scanning array
      if (theIndex > -1) {
        this.scanningAccount.splice(theIndex, 1)
      }
    },
    continueScanAccount (response, msg) {
      let feData = msg['fe_data']
      let node = null
      let mainAccountId = feData['main_account_id']
      this.waitMainAccountScan(mainAccountId, async () => {
        for (let i = 0; i < response.length; i++) {
          let unMixedNode = response[i]
          if (unMixedNode['ajax_child'] !== '0' && unMixedNode['ajax_child'] !== 0) {
            let indexToOpen = this.findIndexToPut(feData['main_account_id'], unMixedNode['id'])
            if (indexToOpen > -1) {
              node = this.successParseData['n' + mainAccountId][indexToOpen]

              await this.waitSubAccountScan(mainAccountId, indexToOpen)

              this.toggleChild(node['self']['id'], mainAccountId, node['current_level'])
            }
          }
        }

        if (this.loadingChildStatus['n' + mainAccountId] === false) {
          this.removeFromScanning(mainAccountId)
        }
      })
    },
    removeEmptyOrFailAccount (caseStatus, accountId, username) {
      let indexTargetAccount = -1

      let findIndexFn = (e) => {
        return e.account_id === accountId
      }

      switch (caseStatus) {
        case 'empty':
          indexTargetAccount = _.findIndex(this.emptyScanAccount, findIndexFn)
          break
        case 'fail':
          indexTargetAccount = _.findIndex(this.failScanAccount, findIndexFn)
          break
      }

      let indexAccount = _.findIndex(this.accounts, (n) => {
        return n.id === accountId
      })

      this.$swal({
        title: username,
        text: 'Bạn chắc chắn xóa tài khoản này ? Gồm toàn bộ các tài khoản cấp dưới',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Xóa',
        denyButtonText: `Hủy`
      }).then((result) => {
        if (result.isConfirmed) {
          api.account.delete(accountId).then(async () => {
            this.$swal({
              icon: 'success',
              title: 'Xóa thành công'
            })
            switch (caseStatus) {
              case 'empty':
                this.emptyScanAccount.splice(indexTargetAccount, 1)
                break
              case 'fail':
                this.failScanAccount.splice(indexTargetAccount, 1)
                break
            }

            if (indexAccount > -1) this.accounts.splice(indexAccount, 1)
          }).catch(() => {
            this.$swal({
              icon: 'error',
              title: 'Lỗi...',
              text: this.serverError
            })
          })
        } else if (result.isDenied) {

        }
      })
    },
    // this for test purpose only
    actionOnSocketFail () {
      // stop all the scanning account and mark them to fail status
      if (this.scanningAccount.length > 0) {
        _.each(this.scanningAccount, (e) => {
          let mainAccountId = e['fe_data']['main_account_id']
          let theIndex = this.getScanningIndex(mainAccountId)

          if (this.loadingChildStatus['n' + mainAccountId]) { this.loadingChildStatus['n' + mainAccountId] = false }

          if (this.scanningAccount[theIndex]) {
          // add to error scanning array before removing
            if (this.scanningAccount[theIndex]) { this.failScanAccount.push(_.extend(this.scanningAccount[theIndex], { _message: 'Socket error' })) }
          }
        })
        this.scanningAccount = []
        this.emittingScanningAccount = 0
      }
    },
    actionUnsubcribeEventSocket () {
      // this.sockets.unsubscribe('success')
      // this.sockets.unsubscribe('error')
      // this.sockets.unsubscribe('scan_success')
      // this.sockets.unsubscribe('scan_error')
      // this.sockets.unsubscribe('scan_step')
    },
    ...mapActions({
      'updateSelectedAccount': 'Report/updateSelectedAccount'
    })
  }
}
</script>
